import api from './api';
import { API_CONFIG } from '../config/apiConfig';
import { DashboardDetails } from '../types/dashboard';

export const getDashboardDetails = async (userName: string, userRole: string): Promise<DashboardDetails> => {
  try {
    const response = await api.get<DashboardDetails>(
      `${API_CONFIG.BASE_URL}/PortalDashboard/GetPortalDashboardDetails`,
      { params: { userName, userRole } }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dashboard details:', error);
    // Return a default object or re-throw to be handled by the caller
    return { totalUsers: 0, totalTrainers: 0, activeModules: 0 };
  }
}; 